import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { adminApi } from "@/lib/api";

const FIELDS = [
  ["empresa", "Nombre de la empresa"],
  ["email", "Correo electrónico"],
  ["telefono", "Teléfono"],
  ["whatsapp", "WhatsApp (solo dígitos con código de país)"],
  ["whatsapp_display", "WhatsApp (formato visible)"],
  ["horario", "Horario de atención"],
  ["pais", "País"],
  ["direccion", "Dirección"],
  ["modalidad", "Modalidad de servicios"],
  ["linkedin", "LinkedIn URL"],
  ["instagram", "Instagram URL"],
  ["facebook", "Facebook URL"],
  ["hero_titulo", "Hero — título"],
  ["hero_subtitulo", "Hero — subtítulo"],
  ["hero_confianza", "Hero — frase de confianza"],
  ["mision", "Misión"],
  ["vision", "Visión"],
  ["historia", "Historia de la compañía"],
];

const TEXTAREAS = new Set(["mision", "vision", "historia", "hero_subtitulo", "hero_titulo"]);

export default function AdminSiteContent() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.siteGet().then((d) => { setForm(d || {}); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await adminApi.siteUpdate(form); toast.success("Configuración guardada"); }
    catch { toast.error("Error al guardar"); }
  };

  if (loading) return <div className="p-10">Cargando...</div>;

  return (
    <div className="p-8 md:p-10" data-testid="admin-site-content">
      <div className="eyebrow mb-2">— Sitio</div>
      <h1 className="font-serif text-4xl">Información y textos del sitio</h1>
      <p className="mt-2 text-sm text-[#4A4A4A]">Datos de contacto, redes y copy principal.</p>

      <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 max-w-4xl">
        {FIELDS.map(([name, label]) => (
          <div key={name} className={TEXTAREAS.has(name) ? "md:col-span-2" : ""}>
            <label className="eyebrow block mb-1">{label}</label>
            {TEXTAREAS.has(name) ? (
              <textarea
                value={form[name] || ""}
                onChange={(e) => setForm((s) => ({ ...s, [name]: e.target.value }))}
                rows={3}
                className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-2 focus:border-[#1B3B2B] focus:outline-none text-sm resize-y"
                data-testid={`site-${name}`}
              />
            ) : (
              <input
                value={form[name] || ""}
                onChange={(e) => setForm((s) => ({ ...s, [name]: e.target.value }))}
                className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-2 focus:border-[#1B3B2B] focus:outline-none text-sm"
                data-testid={`site-${name}`}
              />
            )}
          </div>
        ))}
        <div className="md:col-span-2 pt-6">
          <button type="submit" className="kb-btn" data-testid="site-save">
            <Save className="w-4 h-4" /> Guardar cambios
          </button>
        </div>
      </form>
    </div>
  );
}
